import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // Context
  configuredServiceId: null,
  readOnly: false,

  // UI state
  selectedDay: null,
  editModeDismissed: false,
  pendingPeriodEdit: null,

  // Service data
  serviceName: '',
  price: 0,
  containerCount: 0,
  isRecurringService: false,
  serviceStartDate: null,

  // Metadata
  rentalFeeResetCount: 0,
  existingRentalFee: null,
  hasRentalFee: false,
  noRentalFees: false,

  // Scenario flags
  isNewRentalFee: false,
  isLatestPeriodClosed: false,
  isLatestPeriodOngoing: false,
  isOngoingRentalFee: false,
  isStartDateDeletable: true,
  canUndoReset: false,

  // Dates
  latestRentalPeriodStartDate: null,

  // Work orders
  eventsByDate: {},
  selectedDayWorkOrders: [],

  // Loading
  isGetLoading: false,
  isSaveLoading: false,
}

const rentalFeeDialogSlice = createSlice({
  name: 'rentalFeeDialog',
  initialState,
  reducers: {
    setRentalFeeDialogState: (state, action) => {
      Object.assign(state, action.payload)
    },
    setSelectedDay: (state, action) => {
      state.selectedDay = action.payload
    },
    setEditModeDismissed: (state, action) => {
      state.editModeDismissed = action.payload
    },
    setPendingPeriodEdit: (state, action) => {
      state.pendingPeriodEdit = action.payload
    },
    resetRentalFeeDialogState: () => initialState,
  },
})

export const { setRentalFeeDialogState, setSelectedDay, setEditModeDismissed, setPendingPeriodEdit, resetRentalFeeDialogState } =
  rentalFeeDialogSlice.actions

// Selectors
const selectSlice = s => s.rentalFeeDialog

export const selectConfiguredServiceId = s => selectSlice(s).configuredServiceId
export const selectReadOnly = s => selectSlice(s).readOnly
export const selectSelectedDay = s => selectSlice(s).selectedDay
export const selectEditModeDismissed = s => selectSlice(s).editModeDismissed
export const selectPendingPeriodEdit = s => selectSlice(s).pendingPeriodEdit
export const selectServiceName = s => selectSlice(s).serviceName
export const selectPrice = s => selectSlice(s).price
export const selectContainerCount = s => selectSlice(s).containerCount
export const selectIsRecurringService = s => selectSlice(s).isRecurringService
export const selectServiceStartDate = s => selectSlice(s).serviceStartDate
export const selectRentalFeeResetCount = s => selectSlice(s).rentalFeeResetCount
export const selectExistingRentalFee = s => selectSlice(s).existingRentalFee
export const selectHasRentalFee = s => selectSlice(s).hasRentalFee
export const selectNoRentalFees = s => selectSlice(s).noRentalFees
export const selectIsNewRentalFee = s => selectSlice(s).isNewRentalFee
export const selectIsLatestPeriodClosed = s => selectSlice(s).isLatestPeriodClosed
export const selectIsLatestPeriodOngoing = s => selectSlice(s).isLatestPeriodOngoing
export const selectIsOngoingRentalFee = s => selectSlice(s).isOngoingRentalFee
export const selectIsStartDateDeletable = s => selectSlice(s).isStartDateDeletable
export const selectCanUndoReset = s => selectSlice(s).canUndoReset
export const selectLatestRentalPeriodStartDate = s => selectSlice(s).latestRentalPeriodStartDate
export const selectEventsByDate = s => selectSlice(s).eventsByDate
export const selectSelectedDayWorkOrders = s => selectSlice(s).selectedDayWorkOrders
export const selectIsGetLoading = s => selectSlice(s).isGetLoading
export const selectIsSaveLoading = s => selectSlice(s).isSaveLoading

export default rentalFeeDialogSlice.reducer
